import styled, { css } from 'styled-components';

export const StyledButton = styled.button<{
  isCollapsed?: boolean;
  white?: boolean;
  whiteBackground?: boolean;
  small?: boolean;
  large?: boolean;
  boxShadow?: boolean;
  borderRadius?: number;
  noTargetPadding?: boolean;
  targetFontWeight?: number;
  targetMargin?: string;
}>`
  display: flex;
  align-items: center;
  background: transparent;
  border: none;
  width: 100%;
  outline: 0;
  cursor: pointer;
  font-weight: bold;
  text-align: left;

  ${({ isCollapsed, theme }) => isCollapsed && css`
    background: ${theme.colors.gray1};
    color: ${theme.colors.primary};
  `}

  ${({ isCollapsed, theme, white }) => isCollapsed && white && css`
    background: ${theme.colors.white};
  `}

  ${({ isCollapsed, theme, whiteBackground }) => isCollapsed && whiteBackground && css`
    background: ${theme.colors.white};
    color: ${theme.colors.light};
  `}

  ${({ isCollapsed, theme }) => !isCollapsed && css`
    background: ${theme.colors.primary};
    color: ${theme.colors.white};
  `}

  ${({ isCollapsed, theme, whiteBackground }) => !isCollapsed && whiteBackground && css`
    background: ${theme.colors.white};
    color: ${theme.colors.light};
  `}

  &:hover {
    ${({ isCollapsed, theme }) => isCollapsed && css`
      background: ${theme.colors.blue12};
      color: ${theme.colors.light};
    `}

    ${({ isCollapsed, theme, whiteBackground }) => isCollapsed && whiteBackground && css`
      background: ${theme.colors.white};
      text-decoration: underline;
    `}

    ${({ isCollapsed, theme }) => !isCollapsed && css`
      background: ${theme.colors.light};
    `}

    ${({ isCollapsed, theme, whiteBackground }) => !isCollapsed && whiteBackground && css`
      background: ${theme.colors.white};
      color: ${theme.colors.light};
      text-decoration: underline;
    `}
  }

  &:focus-visible, &:focus {
    box-shadow: ${({ theme }) => theme.boxShadows?.focus};
  }

  &:focus:not(&:focus-visible) {
    box-shadow: none;
  }

  &:active {
    ${({ isCollapsed, theme }) => isCollapsed && css`
      background: ${theme.colors.blue14};
      color: ${theme.colors.lighter};
    `}

    ${({ isCollapsed, theme, whiteBackground }) => isCollapsed && whiteBackground && css`
      background: ${theme.colors.white};
    `}

    ${({ isCollapsed, theme }) => !isCollapsed && css`
      background: ${theme.colors.lighter};
    `}

    ${({ isCollapsed, theme, whiteBackground }) => !isCollapsed && whiteBackground && css`
      background: ${theme.colors.white};
      color: ${theme.colors.lighter};
    `}
  }

  ${({ small }) => small && css`
    font-size: 14px;
    height: 50px;
    padding: 13px 14px;
  `};

  ${({ small, large }) => !small && !large && css`
    font-size: 17px;
    height: 62px;
    padding: 13px 14px;
  `};

  ${({ large }) => large && css`
    font-size: 21px;
    height: 74px;
    padding: 19px 14px;
  `};

  ${({ boxShadow }) => boxShadow && css`
    box-shadow: ${({ theme }) => theme.Collapse?.boxShadow};
  `}

  ${({ borderRadius }) => borderRadius && css`
    border-top-left-radius: ${borderRadius}px;
    border-top-right-radius: ${borderRadius}px;
    border-bottom-right-radius: inherit;
    border-bottom-left-radius: inherit;
  `}

  ${({ isCollapsed, borderRadius }) => isCollapsed && css`
    border-radius: ${borderRadius}px;
  `}

  ${({ noTargetPadding }) => noTargetPadding && css`
    padding: 0;
  `}

  ${({ targetFontWeight }) => targetFontWeight && css`
    font-weight: ${targetFontWeight};
  `}

  ${({ targetMargin }) => targetMargin && css`
    margin: ${targetMargin};
  `}
`;

export const StyledContent = styled.div<{small?: boolean; noContentPadding?: boolean}>`
  background: ${({ theme }) => theme.colors.white};

  ${({ small }) => small && css`
    padding: 24px 16px;
  `};

  ${({ small }) => !small && css`
    padding: 36px 16px;
  `};

  ${({ noContentPadding }) => noContentPadding && css`
    padding: 0;
  `};
`;
